import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ResourceCard slots="link, image, heading, text" width="25%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-and-data-extraction/content-based-process-automation/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/1379a74f85cf3244eff36414b12db273/24599/content-processing.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/1379a74f85cf3244eff36414b12db273/a6b7e/content-processing.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/1379a74f85cf3244eff36414b12db273/a6b7e/content-processing.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "content-processing"
    }}>{`Content processing`}</h3>
    <p>{`Quickly and accurately extract data and context from native and scanned PDFs to automate downstream processes using technologies like Robotic Process Automation (RPA) and Natural Language Processing (NLP).`}</p>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-and-data-extraction/data-analysis/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/2e65ed6b1549f368f4f8d77e598c1a08/24599/data-analysis.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/2e65ed6b1549f368f4f8d77e598c1a08/a6b7e/data-analysis.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/2e65ed6b1549f368f4f8d77e598c1a08/a6b7e/data-analysis.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "data-analysis"
    }}>{`Data analysis`}</h3>
    <p>{`Extract data from complex tables including cell data, column and row headers, and table properties for use in machine learning models, analysis, or storage.`}</p>
    <ResourceCard slots="link, image, heading, text" width="25%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/use-cases/content-publishing/digital-content-publishing/"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "238px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.84033613445378%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387059390ad53e74146f9a5a77bfa7e3/24599/content-republishing.webp 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387059390ad53e74146f9a5a77bfa7e3/a6b7e/content-republishing.jpg 238w"],
            "sizes": "(max-width: 238px) 100vw, 238px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/387059390ad53e74146f9a5a77bfa7e3/a6b7e/content-republishing.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "content-republishing"
    }}>{`Content republishing`}</h3>
    <p>{`Republish the content in PDF documents across different media, languages, and formats by extracting not just data but also structural context, text and table formatting, and reading order.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      